<template>
  <div class="hello">
    <div class="one_1">智能AI数字人技术，万种数字场景自由搭建</div>
    <div class="one_2">
      大米智课AI数字人产品功能，可实现自动批量视频生成与虚拟人直播
    </div>
    <el-tabs v-model="activeName">
      <el-tab-pane name="0">
        <template v-slot:label>
          <!-- <i class="el-icon-menu"></i>   -->
          <div class="one_77">
            <img v-if="activeName == 0" src="../assets//数字人/44.png" alt="" />
            <img v-else src="../assets//数字人/444.png" alt="" />
            数字人视频合成
          </div>
        </template>
      </el-tab-pane>
      <el-tab-pane name="1">
        <template v-slot:label>
          <div class="one_77">
            <img
              v-if="activeName == 1"
              src="../assets//数字人/222.png"
              alt=""
            />
            <img v-else src="../assets//数字人/22.png" alt="" />
            数字人克隆
          </div>
        </template>
      </el-tab-pane>
      <el-tab-pane name="2">
        <template v-slot:label>
          <div class="one_77">
            <img
              v-if="activeName == 2"
              src="../assets//数字人/Frame-1.png"
              alt=""
            />
            <img v-else src="../assets//数字人/Frame.png" alt="" />
            数字人直播
          </div>
        </template>
      </el-tab-pane>
      <el-tab-pane name="3">
        <template v-slot:label>
          <div class="one_77">
            <img
              v-if="activeName == 3"
              src="../assets//数字人/111.png"
              alt=""
            />
            <img v-else src="../assets//数字人/11.png" alt="" />
            数字人交互
          </div>
        </template>
      </el-tab-pane>
    </el-tabs>
    <div class="one_3" v-for="(item, i) in items" v-if="i == activeName">
      <div class="one_4">
        <div class="one_5">{{ item.title }}</div>
        <div class="one_6">{{ item.conment }}</div>
        <div class="one_7">
          <div class="one_8" @click="isOpen = !isOpen">
            <div>立即获取</div>
            <img src="../assets//数字人/Union@2x.png" alt="" />
          </div>
          <el-link
            target="_blank"
            href="https://affim.baidu.com/unique_49847201/chat?siteId=19538945&userId=49847201&siteToken=d938ff4f7bae9254e1d97e1fae316cf6"
          >
            <!-- <div class="one_9">
                            <div>立即咨询</div>
                            <img src="../assets/HelloWorld/tubiao/67.png" alt="">
                        </div> -->
          </el-link>
        </div>
      </div>
      <div class="one_ee">
        <img :src="item.img" alt="" />
      </div>
    </div>
    <div class="one_10">
      <div class="one_11">应用场景</div>
      <div class="one_2">
        数字人可以广泛应用于不同的行业领域,打破行业限制,结合箕多模态表现方提供更好的服务,赋能产业
      </div>
      <div class="one_12">
        <!-- <div v-for="(item, i) in itemx" :key="i" class="one_12_1" >
                    <img v-if="panku!=i" :src="item.img " alt="" class="one_13" @mouseenter="aaa(i)" @click="dianji(i)">
                    <img v-if='panku==i' :src="item.imgs" alt="" class="one_13" @click="dianji(i)"  @mouseout="bbb()">
                </div> -->
        <div class="one_12_1">
          <img
            v-if="a1"
            :src="itemx[0].img"
            alt=""
            class="one_13"
            @mouseenter="aaa(0)"
            @click="dianji(0)"
          />
          <img
            v-else
            :src="itemx[0].imgs"
            alt=""
            class="one_13"
            @click="dianji(0)"
            @mouseleave="aaa(0)"
          />
        </div>
        <div class="one_12_1">
          <img
            v-if="a2"
            :src="itemx[1].img"
            alt=""
            class="one_13"
            @mouseenter="aaa(1)"
            @click="dianji(1)"
          />
          <img
            v-else
            :src="itemx[1].imgs"
            alt=""
            class="one_13"
            @click="dianji(1)"
            @mouseleave="aaa(1)"
          />
        </div>
        <div class="one_12_1">
          <img
            v-if="a3"
            :src="itemx[2].img"
            alt=""
            class="one_13"
            @mouseenter="aaa(2)"
            @click="dianji(2)"
          />
          <img
            v-else
            :src="itemx[2].imgs"
            alt=""
            class="one_13"
            @click="dianji(2)"
            @mouseleave="aaa(2)"
          />
        </div>
        <div class="one_12_1">
          <img
            v-if="a4"
            :src="itemx[3].img"
            alt=""
            class="one_13"
            @mouseenter="aaa(3)"
            @click="dianji(3)"
          />
          <img
            v-else
            :src="itemx[3].imgs"
            alt=""
            class="one_13"
            @click="dianji(3)"
            @mouseleave="aaa(3)"
          />
        </div>
        <div class="one_12_1">
          <img
            v-if="a5"
            :src="itemx[4].img"
            alt=""
            class="one_13"
            @mouseenter="aaa(4)"
            @click="dianji(4)"
          />
          <img
            v-else
            :src="itemx[4].imgs"
            alt=""
            class="one_13"
            @click="dianji(4)"
            @mouseleave="aaa(4)"
          />
        </div>
        <div class="one_12_1">
          <img
            v-if="a6"
            :src="itemx[5].img"
            alt=""
            class="one_13"
            @mouseenter="aaa(5)"
            @click="dianji(5)"
          />
          <img
            v-else
            :src="itemx[5].imgs"
            alt=""
            class="one_13"
            @click="dianji(5)"
            @mouseleave="aaa(5)"
          />
        </div>
      </div>
    </div>
    <!-- <button @click="isOpen = !isOpen">切换弹框状态</button>   -->
    <ChildComponent :is-open="isOpen" @update:isOpen="handleUpdate" />
  </div>
</template>

<script>
import { report } from '@/js/utils'
import ChildComponent from '@/components/components/DialogComponent.vue'
export default {
  name: 'NewTalents',
  components: {
    ChildComponent,
  },
  data() {
    return {
      a1: true,
      a2: true,
      a3: true,
      a4: true,
      a5: true,
      a6: true,
      panku: 9,
      activeName: '0',
      isOpen: false,
      items: [
        {
          img: require('../assets//数字人/Group 250.png'),
          title: '数字人视频合成',
          conment:
            '支持灵活配置场景、声音 动作、动效。轻松用数字人制作短视频，无需真人出镜，大批量视频生成。',
        },
        {
          img: require('../assets//数字人/Group 56.png'),
          title: '数字人克隆',
          conment:
            '多种形态的 AI数字人模型，用户可基于模型进行克隆，形打造后可用于IP形象的打造、视频的制作、直播及其它应用场景',
        },
        {
          img: require('../assets//数字人/Group 253.png'),
          title: '数字人直播',
          conment:
            '简易操作，可接入多个直播平台并具备弹幕、点赞、商品推送、录屏支持虚拟人自助直播，等多种互动功能',
        },
        {
          img: require('../assets//数字人/组 2 1.png'),
          title: '数字人交互',
          conment:
            '支持TTSA、STA、唱歌、DUIX交互能力等，支持动作捕捉、面部捕捉，也支持虚拟场景下，真人和数字人同时出场的虚拟直播。',
        },
      ],
      itemx: [
        {
          img: require('../assets/数字人/Group 254.png'),
          imgs: require('../assets/数字人/Frame 3048.png'),
        },
        {
          img: require('../assets/数字人/Group 255.png'),
          imgs: require('../assets/数字人/Frame 3049.png'),
        },
        {
          img: require('../assets/数字人/Group 256.png'),
          imgs: require('../assets/数字人/Frame 3050.png'),
        },
        {
          img: require('../assets/数字人/Group 259.png'),
          imgs: require('../assets/数字人/Frame 3051.png'),
        },
        {
          img: require('../assets/数字人/Group 258.png'),
          imgs: require('../assets/数字人/Frame 3052.png'),
        },
        {
          img: require('../assets/数字人/Group 257.png'),
          imgs: require('../assets/数字人/Frame 3053.png'),
        },
      ],
      http: this.$getCookie('http'),
    }
  },
  mounted() {},
  methods: {
    aaa(i) {
      if (i == 0) {
        this.a1 = !this.a1
      }
      if (i == 1) {
        this.a2 = !this.a2
      }
      if (i == 2) {
        this.a3 = !this.a3
      }
      if (i == 3) {
        this.a4 = !this.a4
      }
      if (i == 4) {
        this.a5 = !this.a5
      }
      if (i == 5) {
        this.a6 = !this.a6
      }
    },
    dianji(i) {
      if (i == 0) {
        this.$setCookie('changjin', '数字人主播')
      }
      if (i == 1) {
        this.$setCookie('changjin', '虚拟客户经理')
      }
      if (i == 2) {
        this.$setCookie('changjin', '智能培训讲师')
      }
      if (i == 3) {
        this.$setCookie('changjin', '产品数字发布会')
      }
      if (i == 4) {
        this.$setCookie('changjin', '行业展销会')
      }
      if (i == 5) {
        this.$setCookie('changjin', '娱乐与文化传播')
      }
      this.isOpen = !this.isOpen
    },
    // aaa(item){ // 移入
    //   this.panku=item
    // },
    // bbb(i,item){ //移出
    //   this.panku=9
    // },
    handleUpdate(newVal) {
      this.isOpen = newVal // 接收到子组件传递的新的 isOpen 值，更新父组件的 isOpen 状态
      // 其他逻辑...
    },
    handleClick2(event) {
      this.$setItem('luyou', this.$route.path)
      report(true)
      this.$removeItem('shijian')
    },
    handleClick(tab, event) {
      console.log(tab, event)
    },
  },
}
</script>

<style lang="scss" scoped>
.one_ee {
  overflow: hidden;
  img {
    width: 800px;
    transform: scale(1);
    transition: transform 0.3s ease;
  }
  img:hover {
    transform: scale(1.05);
  }
}
.hello {
  width: 1200px;
  //  background: rgb(224, 213, 4);
  //    background: linear-gradient(90deg, #f7f8fc 0, #ebf8fe 100%);
  //  height: 1672px;
  //  margin: 0 0 30px;
  display: flex;
  align-items: center;
  flex-direction: column;
}
.one_1 {
  margin: 55px 0 24px;
  height: 56px;
  font-size: 40px;
  font-weight: 500;
  color: #121221;
  line-height: 56px;
}
.one_2 {
  height: 18px;
  font-size: 16px;
  font-weight: 400;
  color: #666666;
  line-height: 18px;
  margin-bottom: 26px;
}
::v-deep .el-tabs--top {
  width: 100%;
}
::v-deep .el-tabs__nav {
  width: 100%;
}
::v-deep .el-tabs__active-bar {
  width: 25% !important;
  padding: 0;
}
::v-deep .el-tabs__item {
  width: 25% !important;
  text-align: center;
  height: 88px;
  line-height: 88px;
  font-size: 18px;
  font-weight: bold;
  color: #666666;
}
::v-deep .el-tabs__item {
  padding: 0;
}
::v-deep .el-tabs__content {
  display: none;
}
::v-deep .el-tabs__header {
  margin: 0;
}
::v-deep .el-tabs__active-bar {
  background-color: #eb5b05;
}
::v-deep .is-active {
  color: #eb5b05;
}

.one_3 {
  margin: 50px 0 0;
  width: 100%;
  height: 400px;
  display: flex;
  justify-content: space-between;
}
.one_4 {
  width: 407px;
}
.one_5 {
  margin: 78px 0 32px;
  font-size: 28px;
  font-weight: 500;
  color: #333333;
  line-height: 24px;
}
.one_6 {
  font-size: 16px;
  color: #333333;
  margin: 0 0 50px;
  line-height: 24px;
  min-height: 72px;
}
.one_7 {
  display: flex;
}
.one_8 {
  margin: 0 40px 0 0;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer !important;
  font-size: 14px;
  color: #ffffff;
  width: 154px;
  height: 46px;
  background: linear-gradient(90deg, #eb6215 0%, #ebaf15 100%);

  img {
    height: 14px;
    margin: 0 0 0 6px;
  }
}
.one_9 {
  display: flex;
  width: 154px;

  color: #eb6415;
  font-size: 14px;
  height: 46px;
  border: 1px solid #eb6415;
  align-items: center;
  justify-content: center;
  img {
    margin: 2px 0 0;
    width: 22px;
  }
}
.one_10 {
  // margin: 47px 0 0;
  width: 100%;
  // height: 468px;
  display: flex;
  flex-direction: column;
  align-items: center;
  // justify-content: center;
}
.one_11 {
  height: 34px;
  font-size: 24px;
  font-weight: 500;
  margin: 14px;
  color: #121221;
  line-height: 34px;
}
.one_12 {
  margin: 40px 0 0;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
}
.one_12_1 {
  position: relative;
  cursor: pointer;
}
.one_13 {
  width: 380px;
  height: 230px;
  margin: 0 0 60px;
}
.one_14 {
  width: 100px;
  height: 30px;
  position: absolute;
  bottom: 104px;
  left: 30px;
  font-size: 16px;
  background: rgb(255, 255, 255);
  text-align: center;
  line-height: 30px;
  color: #eb6415;
  cursor: pointer;
}
// ::v-deep .el-tabs__item img{
//     top: 34px;
//     position: absolute;
//     width: 18px;
//     left: 62px;
// }
.one_77 {
  display: flex;
  align-items: center;
  justify-content: center;
  img {
    width: 19px;
    height: 19px;
    margin-right: 6px;
  }
}
</style>
